import Model from './model.js'

export default {
  ReadReport(params) {
    if(params.action === 'Next') {
      params.data.url = params.self.state.nextPage;
    }
    
    Model.ReadReport(params);
  },
  ReadAssetTotalValue(params) {
    // if(params.action === 'Next') {
    //   params.data.url = params.self.state.nextPage;
    // }
    
    Model.ReadAssetTotalValue(params);
  },
  ReadAsMaster(params) {
    if(params.action === 'asset_status'){
      params.data.query = 'Master/Asset-Status-Master/';

    } else if(params.action === 'type_master') {
      params.data.query = 'Master/Asset-Type-Master/';

    } else if(params.action === 'user_master') {
      params.data.query = 'User/Master/All/';

    } else if(params.action === 'sites_master') {
      params.data.query = 'Location/Sites-Master/';

    } else if(params.action === 'location_master'){
      params.data.query = 'Location/Master/';
    } else {
      params.data.query = 'Master/Vendor-Master/';
    }
    Model.ReadAsMaster(params)
  },
  DownloadReport(params) {
    Model.DownloadReport(params);
  }
}




// WEBPACK FOOTER //
// ./src/App/report/presenter.js